module.exports = __webpack_public_path__ + "static/media/picture-(1).f308ff79.JPG";